/** @format */

import { Component, inject, OnInit, input } from '@angular/core';

import {
	Chain,
	Environment,
	ProcessedNonBundleProduct,
	ProductStyle
} from '@shared/data-access/interfaces';
import { CommonModule } from '@angular/common';
import { UtilityService } from '@shared/utils/services';

@Component({
	selector: 'pdp-product-info-specs',
	imports: [CommonModule],
	templateUrl: './product-info-specs.component.html',
	styleUrls: ['./product-info-specs.component.scss']
})
export class ProductInfoSpecsComponent implements OnInit {
	public chain = inject(Chain);
	private readonly utilityService = inject(UtilityService);
	private readonly environment = inject(Environment);

	backgroundImage = input<string>();
	sectionTitle = input<string>('About This Item');
	product = input<ProcessedNonBundleProduct | ProductStyle>();
	descriptiveH2Enabled: boolean;
	descriptiveH2Text: string;

	ngOnInit(): void {
		this.descriptiveH2Enabled = this.utilityService.checkKillSwitch(
			'isDescriptiveH2Enabled',
			this.environment.killSwitch,
			this.chain.chainIdentifierAbbr
		);
		if (this.descriptiveH2Enabled) {
			const subtitleAttribute = this.product().descriptiveAttributes.find(
				(attr) => attr.name == 'Subtitle'
			);
			this.descriptiveH2Text = subtitleAttribute.value.toString();
		}
	}
}
